import axios from "axios";
import store from "@/store";
import router from "@/router";

// const IS_PRODUCTION = process.env.NODE_ENV === "production";

// Make Axios play nice with Django CSRF
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

const isHandlerEnabled = (config = {}) => {
  return Object.prototype.hasOwnProperty.call(config, "handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

const errorHandler = error => {
  if (isHandlerEnabled(error.config)) {
    switch (error.status) {
    case 400: {
      let errorMsg;
      if (
        error.config.url ===
            process.env.VUE_APP_DRF_API_URL + "/auth/registration/" ||
          error.config.url ===
            process.env.VUE_APP_DRF_API_URL + "/auth/password/reset/"
      ) {
        errorMsg = error.data.email[0];
      } else {
        errorMsg = error.data.non_field_errors[0];
        /* Above statement throws error, "Uncaught (in promise) TypeError: Cannot read property '0' of undefined"
      error.data return an object that has a survey property that has the error
      Might need to change to error.data.survey[0] */
      }
      return store.dispatch("auth/showBadRequestAlert", errorMsg);
    }
    case 401:
      localStorage.removeItem("TOKEN_STORAGE_KEY");
      router.push('/login')
      break;
    case 403:
      alert("forbidden");
      break;
    case 404:
      if (
        error.config.url.includes(
          process.env.VUE_APP_DRF_API_URL + "/auth/verify-email/"
        )
      ) {
        // store.dispatch("auth/showBadRequestAlert", "We were unable to verify your email. Please try again later.")
      } else {
        alert("not found");
      }
      break;
    case 500:
      alert("internal server error");
      break;
    case 502:
      alert("bad gateway");
      break;
    case 503:
      alert("service unavailable");
      break;
    case 504:
      alert("gateway timeout");
      break;
    default:
      alert("hopefully network error");
      return store.dispatch("stakeholders/showNetworkAlert");
    }
  }
  return Promise.reject({ ...error });
};

const successHandler = response => {
  // if (isHandlerEnabled(response.config)) {
  //   // [do something on success]
  //   console.log("success");
  // }
  return response;
};

const api = axios.create({
  baseURL: process.env.VUE_APP_DRF_API_URL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error.response)
);

const openEndpoints = {
  "content_type/": "get",
  "email_templates/email_stakeholder_on_survey_submittal/": "post",
  "exhibits/get_exhibit_files/": "post",
  "messages/": "post",
  "messages/get_conversation/messages/": "post",
  "program/": "get",
  "project/": "get",
  "responseJSON/": "post",
  "stakeholders/": "post",
  "stakeholders/get_stakeholder_names/": "get",
  "stakeholders/look_up_stakeholder/": "post",
  "surveyJSON/": "get",
  "users/get_user_names/": "get",
  "users/notify_admin/": "post"
}

const useToken = (config) => {
  if (config.url.match(/stakeholders\/[0-9]+/) && config.method === "patch") {
    return false
  } if (config.url in openEndpoints && config.method === openEndpoints[config.url]) {
    return false
  } else {
    return true
  }
}

// Set the AUTH token for any request
api.interceptors.request.use(function(config) {
  if (useToken(config)) {
    const token = localStorage.getItem("TOKEN_STORAGE_KEY");
    config.headers.Authorization = token ? `JWT ${token}` : "";
  } else {
    config.headers.Authorization = "";
  }
  return config;
});

export default api;
